"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardsFiltersSortBy = void 0;
var BoardsFiltersSortBy;
(function (BoardsFiltersSortBy) {
    BoardsFiltersSortBy["recentlyViewed"] = "recentlyViewed";
    BoardsFiltersSortBy["reverseCreatedAt"] = "reverseCreatedAt";
    BoardsFiltersSortBy["createdAt"] = "createdAt";
    BoardsFiltersSortBy["alphabetical"] = "alphabetical";
    BoardsFiltersSortBy["reverseAlphabetical"] = "reverseAlphabetical";
    BoardsFiltersSortBy["recentlyUpdated"] = "recentlyUpdated";
    BoardsFiltersSortBy["oldestUpdated"] = "oldestUpdated";
    // for compatibility with table view clip endpoint
    BoardsFiltersSortBy["nameAlphabetical"] = "nameAlphabetical";
    BoardsFiltersSortBy["nameReverseAlphabetical"] = "nameReverseAlphabetical";
    BoardsFiltersSortBy["recentlyCreated"] = "recentlyCreated";
    BoardsFiltersSortBy["oldestCreated"] = "oldestCreated";
    BoardsFiltersSortBy["recordedAt"] = "recordedAt";
    BoardsFiltersSortBy["oldestRecorded"] = "oldestRecorded";
    BoardsFiltersSortBy["recentlyRecorded"] = "recentlyRecorded";
    BoardsFiltersSortBy["custom"] = "custom";
})(BoardsFiltersSortBy || (exports.BoardsFiltersSortBy = BoardsFiltersSortBy = {}));
//# sourceMappingURL=board.js.map